﻿class MailingList {
  constructor() {
    this.props = {
      mailingListEl: document.getElementsByClassName('mailingList')[0],
      emailInput: document.getElementById('form__email')
    };
    this.bind();
  }
  bind() {

    const { mailingListEl } = this.props;

    if (mailingListEl) {

      this.getByEmail(mailingListEl);
    }

  }
  getByEmail(el) {

    const { emailInput } = this.props;

    var email = el.getAttribute('data-email');

    if (emailInput && emailInput.value !== '') {
      email = emailInput.value;
    }

    var xhr = new XMLHttpRequest();
    xhr.open('GET', 'umbraco/surface/mailinglist/get?email=' + email);

    xhr.onload = function () {

      var resp = JSON.parse(xhr.response);


      if (resp.success) {

        el.querySelector('.checkbox').setAttribute('data-checked', 'true');
        el.querySelector('.checkbox input').checked = true;

      }

    };

    xhr.send();

  }
}

export default MailingList;
